import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';
import { getRTLPopperStyles } from '~/modules/common/util';
import { useBulkAcceptAllocationsForResourceRequest } from '~/modules/resourcing/common/hooks';
import { useAllocationChartContext } from '~/modules/projects/resourcing-plan/ResourcingPlanPage/contexts';
import useStyles from './useStyles';

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    display: 'flex'
  })
}));

export const ResourceMatchItemAcceptButton = ({
  dataQeId,
  resourceRequest
}) => {
  const classes = useStyles();
  const tooltipPopperClasses = useTooltipPopperStyles();
  const { formatMessage } = useIntl();
  const { resourceMatches } = resourceRequest;
  const [resourceMatch] = resourceMatches;
  const checkMarkDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemAcceptButton`
    : undefined;
  const acceptTooltipTitle = formatMessage({
    id: 'resourceMatchItem.acceptResource'
  });

  const allocationChartContext = useAllocationChartContext();
  const {
    bulkAcceptAllocationsForResourceRequest
  } = useBulkAcceptAllocationsForResourceRequest();

  const handleAccept = useCallback(
    _event => {
      bulkAcceptAllocationsForResourceRequest({
        acceptAllocationInput: [
          {
            resourceRequestId: resourceRequest.id,
            userIds: resourceMatch ? [resourceMatch.userUri] : []
          }
        ],
        allocationChartRef: allocationChartContext?.allocationChartRef
      });
    },
    [
      resourceRequest,
      allocationChartContext?.allocationChartRef,
      bulkAcceptAllocationsForResourceRequest
    ]
  );

  return (
    <ButtonBase
      data-qe-id={checkMarkDataQeId}
      className={classes.itemButtonShadow}
      onClick={handleAccept}
    >
      <Tooltip
        title={acceptTooltipTitle}
        aria-label={acceptTooltipTitle}
        aria-hidden={false}
        placement="bottom-start"
        classes={tooltipPopperClasses}
      >
        <CheckCircle className={classes.itemButtonIcon} />
      </Tooltip>
    </ButtonBase>
  );
};

ResourceMatchItemAcceptButton.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired
};

export default ResourceMatchItemAcceptButton;
